export default function navigation() {
  const postMain = document.querySelector('.post-main');
  if (!postMain) {
    console.warn('No .post-main element found');
    return;
  }
  const navigation = document.querySelectorAll('.post-navigation');
  const headers = postMain.querySelectorAll('h2');
  const headerData = [];
  headers.forEach((header) => {
    if (header.classList.contains('post-title')) return;
    const linkClass = `post-navigation-link-${header.id}`;
    headerData.push({
      className: linkClass,
      top: header.getBoundingClientRect().top,
    });
    navigation.forEach((navigation) => {
      navigation.innerHTML += `<a href="#${header.id}" class="post-navigation-link ${linkClass}">${header.textContent}</a>`;
    });
  });

  const onScroll = () => {
    const postContentEnd = document.querySelector('#post-content-end');
    const TOP_OFFSET = 124;
    if (postContentEnd) {
      const postRight = document.querySelector('.post-right');
      const postRightBox = document.querySelector('.post-right-box');
      const postLeftBox = document.querySelector('.post-left-box');
      const postLeft = document.querySelector('.post-left');
      if (!postRight || !postLeft || !postRightBox || !postLeftBox) {
        console.warn(
          `.post-right: '${postRight}', .post-left: '${postLeft}', .post-right-box: '${postRightBox}', .post-left-box: '${postLeftBox}'`,
        );
        return;
      }
      if (
        window.scrollY + postRightBox.getBoundingClientRect().bottom >=
          postContentEnd.offsetTop ||
        window.scrollY + postLeftBox.getBoundingClientRect().bottom >=
          postContentEnd.offsetTop
      ) {
        postRight.style.opacity = 0;
        postRight.style.visibility = 'hidden';
        postLeft.style.opacity = 0;
        postLeft.style.visibility = 'hidden';
      } else {
        postRight.style.opacity = 1;
        postRight.style.visibility = 'visible';
        postLeft.style.opacity = 1;
        postLeft.style.visibility = 'visible';
      }
    } else {
      console.warn('#post-content-end not found');
    }
    const postLinks = document.querySelectorAll('.post-navigation-link');
    postLinks.forEach((postLink) => {
      postLink.classList.remove('post-navigation-link-active');
    });
    const scrolled = headerData.filter(
      (header, index) =>
        window.scrollY + TOP_OFFSET >= header.top || index === 0,
    );
    const last = scrolled.at(-1);
    if (!last) return;
    const activePostLinks = Array.from(
      document.getElementsByClassName(last.className),
    );
    activePostLinks.forEach((postLink) => {
      postLink.classList.add('post-navigation-link-active');
    });
  };

  onScroll();

  window.addEventListener('scroll', onScroll);
}
